var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxDistance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm9.949 11h-2.019c-.451-3.617-3.313-6.479-6.93-6.931v-2.018c4.717.47 8.479 4.232 8.949 8.949zm-4.039 2c-.424 2.507-2.403 4.486-4.91 4.91v-2.91h-2v2.91c-2.507-.424-4.486-2.403-4.91-4.91h2.91v-2h-2.91c.424-2.507 2.403-4.486 4.91-4.91v2.91h2v-2.91c2.507.423 4.486 2.402 4.91 4.91h-2.91v2h2.91zm-6.91-10.949v2.019c-3.617.451-6.479 3.313-6.931 6.93h-2.018c.47-4.717 4.232-8.479 8.949-8.949zm-8.949 10.949h2.019c.452 3.617 3.313 6.479 6.931 6.931v2.019c-4.718-.471-8.48-4.233-8.95-8.95zm10.949 8.949v-2.019c3.617-.452 6.479-3.313 6.931-6.931h2.019c-.471 4.718-4.233 8.48-8.95 8.95z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxDistance);
export default __webpack_public_path__ + "static/media/box-distance.dce8422bdeb466b7711822ba1be4031e.svg";
export { ForwardRef as ReactComponent };